/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    size?: number;
    /**
     * 
     */
    pages?: number;
    /**
     * 
     */
    subtype?: string;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner(value: object): value is MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    return true;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'size': json['size'] == null ? undefined : json['size'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'subtype': json['subtype'] == null ? undefined : json['subtype'],
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSONTyped(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'size': value['size'],
        'pages': value['pages'],
        'subtype': value['subtype'],
    };
}

